<template>
	<v-dialog
		v-model="visible"
		persistent
		max-width="420"
		:retain-focus="false"
	>
		<v-card rounded="lg" elevation="1">
			<v-card-title class="bg-warning text-white d-flex align-center py-3">
				<v-icon start>mdi-clock-alert-outline</v-icon>
				{{ t("session.timeout.title") }}
			</v-card-title>

			<v-card-text class="pt-4 text-center">
				<p class="mb-3">{{ t("session.timeout.message") }}</p>
				<p class="text-h4 font-weight-bold text-warning mb-0">
					{{ t("session.timeout.countdown", { seconds }) }}
				</p>
			</v-card-text>

			<v-card-actions class="px-4 pb-4">
				<v-spacer />
				<v-btn variant="text" @click="onLogout">
					{{ t("session.timeout.logout") }}
				</v-btn>
				<v-btn color="primary" variant="flat" @click="onContinue">
					{{ t("session.timeout.continue") }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useAuthStore } from "@/stores/auth";
import {
	sessionWarningVisible,
	sessionWarningSeconds,
	continueSession,
} from "@/services/sessionManager";

const { t } = useI18n();
const authStore = useAuthStore();

// Refs compartilhados com o gerenciador de sessão.
const visible = sessionWarningVisible;
const seconds = sessionWarningSeconds;

function onContinue() {
	continueSession();
}

function onLogout() {
	// O watcher em App.vue chama stopSessionManager() ao deslogar, escondendo o aviso.
	void authStore.logout();
}
</script>
